import Icon from './Icon';

// Shown on phones for screens we deliberately did not optimize for mobile.
export default function DesktopOnlyNotice({ title }) {
  return (
    <div style={{ textAlign: 'center', padding: 'var(--space-8) var(--space-4)', color: 'var(--color-fg-muted)' }}>
      <Icon name="desktop" size={28} />
      <h2 style={{ marginTop: 'var(--space-3)', color: 'var(--presto-suit)' }}>{title}</h2>
      <p style={{ fontSize: 'var(--text-small)' }}>
        This screen is best used on a computer. On your phone, use My Day, Leads, and Log Touchpoint.
      </p>
    </div>
  );
}
